export default "https://assets-v2.scaler.com/packs/images/stars-icon.551f0e.svg";